import { render, staticRenderFns } from "./ChatTable.vue?vue&type=template&id=6c8aed13&lang=pug"
import script from "./ChatTable.vue?vue&type=script&lang=js"
export * from "./ChatTable.vue?vue&type=script&lang=js"
import style0 from "./ChatTable.vue?vue&type=style&index=0&id=6c8aed13&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports